<template>
  <!-- 菜单权限管理 -->
  <div class="paddbox autobox">
    <div>
      <el-card>
        <el-tabs v-model="accountType" type="border-card">
          <el-tab-pane label="组织" name="EBP">
            <div>
              <!-- <el-input placeholder="请输入组织名称" v-model="filterText" clearable></el-input> -->
              <!-- <el-tree class="filter-tree" :data="treeData" :props="defaultProps" :filter-node-method="filterNode"
                @node-click="handleNodeClick" ref="treeRef">
                <template #default="{ node, data }">
                  <span class="custom-tree-item">
                    <span class="level-tag">{{ node.level }}</span>
                    <span class="tree-label">{{ data.name }}</span>
                  </span>
                </template>
</el-tree> -->
              <el-select v-model="sid" clearable placeholder="请选择推送组织" style="width: 400px">
                <el-option v-for="item in DeptData" :key="item.config.teamId" :label="item.config.teamName"
                  :value="item.config.teamId">
                </el-option>
              </el-select>
              <el-divider></el-divider>
              <div class="fontBtn flex" v-if="sid != ''">
                <!-- <div>
                  <font>已选中部门：</font>
                  <font style="color:red">{{ name }}</font>
                </div> -->
                <div>
                  <el-button type="primary" size="mini" @click="BMtc()">确定推送</el-button>
                </div>
              </div>

            </div>


          </el-tab-pane>
          <el-tab-pane label="广告主账户" name="ADVERTISER">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="巨量账户id：">
                <el-input v-model="accountId" placeholder="请输入巨量账户id" size="mini"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="ZHtc()" size="mini">确定推送</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>

        </el-tabs>

        <!-- table部分 -->
        <div></div>
        <!-- 分页 -->

      </el-card>
    </div>

    <div>



    </div>
  </div>
</template>

<script>
import { teamAccounttree, juliangvideoupload, juliangmeitivideopullmylist } from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { inject, reactive, toRefs, watch, ref } from 'vue'

export default {
  name: 'ylyUploadjuliang',
  components: {},

  props: ['Data'],
  setup(props) {
    //模板ref，不能放进reactive
    const treeRef = ref(null)
    const state = reactive({
      //账户类型
      accountType: 'EBP',
      //点击的节点
      sid: '',
      item: '',
      name: '',
      //账户id
      accountId: '',
      // ==========树相关参数==========
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      // 查询可见的组织
      DeptData: [],
      //点击节点获取值
      handleNodeClick: (data, node) => {
        console.log('点击节点获取值', data, node)
        state.sid = data.id
        state.item = data
        state.name = data.name
      },
      // 部门确定
      BMtc: () => {
        console.log('部门确定', props.Data)
        if (state.sid == '') {
          return ElMessage.error('请先选中部门')
        }
        const datas = {
          accountId: state.sid,
          accountType: state.accountType,
          sourceSucaiObjectIds: props.Data
        }
        state.juliangvideouploadFun(datas)
      },
      //账户确定
      ZHtc: () => {
        console.log('账户确定', props.Data)
        if (state.accountId == '') {
          return ElMessage.error('请先输入巨量账户id')
        }
        const datas = {
          accountId: state.accountId,
          accountType: state.accountType,
          sourceSucaiObjectIds: props.Data
        }
        state.juliangvideouploadFun(datas)
      },
      //推送到巨量
      juliangvideouploadFun: (datas) => {
        juliangvideoupload(datas).then((res) => {
          console.log('推送到巨量', res)
          if (res.code == 200) {
            state.sid = ''
            return ElMessage.success('任务已提交，后台处理中,请稍后')

          }
        })
      }
    })





    const filterNode = (value, data) => {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    }


    // //查询树
    // const teamAccounttreeFun = () => {
    //   teamAccounttree({}).then((res) => {
    //     state.treeData = res.data
    //   })
    // }

    // teamAccounttreeFun()

    //查询可见的组织
    const juliangmeitivideopullmylistFun = () => {
      juliangmeitivideopullmylist({}).then((res) => {
        // state.treeData = res.data
        state.DeptData = res.data
      })
    }

    juliangmeitivideopullmylistFun()


    /**监听树搜索 */
    watch(
      () => state.filterText,
      (val) => {
        treeRef.value?.filter(val)
      }
    )


    return {
      treeRef,
      filterNode,
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      // teamAccounttreeFun,
      juliangmeitivideopullmylistFun,
    }
  },
}
</script>

<style lang="scss" scoped>
.filter-tree {
  margin-top: 10px;
}

.custom-tree-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.level-tag {
  background-color: #e5e7eb;
  color: #666;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.tree-label {
  font-size: 14px;
}


.fontBtn {
  justify-content: space-between
}
</style>
